import { typedGql } from '../../../../zeus/typedDocumentNode'

export const AVAILABLE_ROLES_BY_USER = typedGql('query')({
  availableRolesByUser: true,
})
